<template lang="pug">
div
	v-slide-group(v-model="selectedDate" center-active mandatory)
		v-slide-item(v-for="(bar, i) in bars" :key="i" v-slot="{ active, toggle }" disabled :value="bar.date")
			v-hover( v-slot="{ hover }"  :disabled="bar.value <= 0" close-delay="50")
				.mx-1.text-center.d-flex.flex-column.justify-end( @click="toggle" style="cursor:pointer")
					span(v-if="bar.value < 300 && bar.value > 0" :class="active ? 'font-weight-bold' : ''") {{bar.barLabel}}
					v-sheet(:color="active? 'accent' : hover? 'primary': '#DFEDF7'" width="70" :height="bar.value/10" rounded="lg" v-ripple)
						span(v-if="bar.value >= 300" :class="active ? 'white--text font-weight-bold' : ''") {{bar.barLabel}}
					span.font-weight-bold {{bar.label}}
					v-icon(v-if="active" small color="primary") radio_button_checked
					v-icon(v-else small) radio_button_unchecked

</template>

<script>
import gql from 'graphql-tag';
import Barchart from '@dengl/site/components/display/barchart.vue';

const {
	decodeFilters,
	encodeFilters
} = require('@dengl/common/utils/filterstrings');

const query = gql`
	query getAccommodationDetailsOtherWeek($filters: String, $id: ID!) {
		accommodation(id: $id) {
			id
			variants(filters: $filters) {
				id
				price
				date
				filters
			}
		}
	}
`;

export default {
	components: {
		Barchart
	},
	props: {
		accommodationId: {
			type: String,
			required: true
		},
		filterstring: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			otherWeeks: [],
			aborted: false,
			controller: new AbortController(),
			selectedDate: null
		};
	},
	computed: {
		bars() {
			const filters = decodeFilters(this.filterstring, this.$i18n.locale);
			return this.otherWeeks.map(week => {
				return {
					value: week.price,
					label: this.$dayjs(week.date).format('D MMM'),
					date: week.date,
					barLabel: this.$n(
						Math.ceil(week.price),
						'simplecurrency',
						this.$i18n.locale
					),
					active: this.$dayjs(week.date).isSame(this.$dayjs(filters.date))
				};
			});
		},
		filters() {
			return decodeFilters(this.filterstring, this.$i18n.locale);
		}
	},
	watch: {
		selectedDate(val) {
			const newFilterstring = encodeFilters(
				{ ...this.filters, date: val },
				this.$i18n.locale
			);

			this.$router.push(
				this.localePath({
					name: 'accommodations-search-id',
					params: { id: this.accommodationId },
					hash: `#${newFilterstring}`
				})
			);
		},
		filterstring() {
			this.otherWeeks = [];
			this.fetchOtherWeeks();
		},
		accommodationId() {
			this.otherWeeks = [];
			this.fetchOtherWeeks();
		}
	},
	created() {
		this.selectedDate = this.filters.date;
	},
	mounted() {
		this.fetchOtherWeeks();
	},
	destroyed() {
		this.aborted = true;
	},
	methods: {
		async fetchOtherWeeks() {
			const signal = this.controller.signal;
			const filters = decodeFilters(this.filterstring, this.$i18n.locale);

			const day = this.$dayjs(filters.date).day();

			let from = this.$dayjs().day(day);
			const until = this.$dayjs('2023-05-01'); // end of season!

			const dates = [];
			while (from.isBefore(until)) {
				if ([11, 0, 1, 2, 3].includes(from.month())) {
					dates.push(from.clone().format('YYYY-MM-DD'));
					this.otherWeeks.push({
						date: from.clone().format('YYYY-MM-DD'),
						price: 0
					});
				}
				from = from.add(7, 'days');
			}

			let abortRequest = false;

			for (let i = 0; i < dates.length; i++) {
				if (this.aborted || abortRequest) {
					return false;
				}

				filters.date = dates[i];
				await this.$graphClient
					.query({
						query,
						variables: {
							filters: encodeFilters(filters, this.$i18n.locale),
							id: this.accommodationId,
							context: {
								fetchAccoDetail: true
							}
						},
						context: {
							fetchOptions: {
								signal
							}
						}
					})
					.then(({ data }) => {
						data.accommodation.variants = data.accommodation.variants.filter(
							variant => !!variant
						);
						if (data.accommodation.variants.length) {
							const filterstringDecoded = decodeFilters(
								this.filterstring,
								this.$i18n.locale
							);
							const variantFilterDecoded = decodeFilters(
								data.accommodation.variants[0].filters,
								this.$i18n.locale
							);

							delete filterstringDecoded.date;
							delete variantFilterDecoded.date;

							if (
								encodeFilters(filterstringDecoded, this.$i18n.locale) !==
									encodeFilters(variantFilterDecoded, this.$i18n.locale) ||
								this.accommodationId !== data.accommodation.id
							) {
								abortRequest = true;
							}
						}

						data.accommodation.variants.sort((a, b) => {
							return a.price - b.price;
						});
						this.$set(this.otherWeeks, i, {
							date: dates[i],
							price: data.accommodation.variants.length
								? data.accommodation.variants[0].price
								: null
						});
					});
			}
		},
		abortFetchRequest() {
			this.aborted = true;
			this.controller.abort();
		}
	}
};
</script>
